import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { FC, useState } from 'react';
import { DateTime } from 'luxon';
import { COLORS } from 'services/constants/colors';
import { TPreviousErrorsItemProps } from './types';

export const PreviousErrorsItem: FC<TPreviousErrorsItemProps> = ({
	date,
	// description,
	actions,
	communicationWithTheClient,
	comments,
}) => {
	const [expanded, setExpanded] = useState(true);
	const handleExpandClick = () => {
		setExpanded(!expanded);
	};
	return (
		<Box
			key={nanoid()}
			sx={{
				borderRadius: '12px',
				padding: '10px',
				backgroundColor: COLORS.SECONDARY,
				// color: 'primary.main',
			}}
		>
			<Typography
				sx={{
					fontWeight: 'bold',
					marginBottom: '10px',
				}}
				color="primary"
			>
				{DateTime.fromISO(date).toFormat('yyyy-MM-dd')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 1,
				}}
			>
				{/* <Box
					sx={{
						border: '1px solid #016193',
						borderRadius: '12px',
						padding: '10px',
					}}
				>
					<Typography
						sx={{
							marginBottom: '10px',
						}}
						color="primary"
					>
						Error description
					</Typography>
					<Typography>{description}</Typography>
				</Box> */}
				<Box
					sx={{
					border: `1px solid ${COLORS.PRIMARY}`,
					borderRadius: '12px',
					padding: '10px',
				}}
			>
				<Typography
					sx={{
						marginBottom: '10px',
					}}
					color="primary"
				>
					List of actions
				</Typography>
				<Box>
					{actions.map(action => (
						<Typography
							key={nanoid()}
							component="div"
							sx={{
								borderRadius: '20px',
								padding: '5px 10px',
								backgroundColor: 'primary.main',
								color: COLORS.font_light,
									display: 'inline-block',
									m: '4px',
									fontSize: '0.9rem',
									opacity: 0.6,
								}}
							>
								{/* {scripts.find((s) => s.script === action.script)?.name ?? action.script} */}
								{action.scriptName}
							</Typography>
						))}
					</Box>
				</Box>
				{expanded && (
					<>
					<Box
						sx={{
							border: `1px solid ${COLORS.PRIMARY}`,
							borderRadius: '12px',
							padding: '10px',
						}}
					>
						<Typography
							sx={{
								marginBottom: '10px',
							}}
							color="primary"
						>
							Communication with the client
						</Typography>
						<Typography>{communicationWithTheClient}</Typography>
					</Box>
					<Box
						sx={{
							border: `1px solid ${COLORS.PRIMARY}`,
							borderRadius: '12px',
							padding: '10px',
						}}
						>
							<Typography
								sx={{
									marginBottom: '10px',
								}}
								color="primary"
							>
								Comments
							</Typography>
							<Typography>{comments}</Typography>
						</Box>
					</>
				)}
				<Button
					color="primary"
					sx={{
						textTransform: 'none',
						width: 'fit-content',
						m: 0,
						p: 0,
					}}
					onClick={handleExpandClick}
				>
					{expanded ? 'Hide details' : 'Show details'}
				</Button>
			</Box>
		</Box>
	);
};
